<m-loader-container>
    <router-outlet></router-outlet>
</m-loader-container>
